import Parallax from 'parallax-js';
import simpleParallax from 'simple-parallax-js';
import './utils/sliders';

const parallaxEffect = document.getElementsByClassName('main-steps-effect');
const parallaxEffect2 = document.getElementsByClassName('blue-small-circle');
const parallaxEffect3 = document.getElementsByClassName('blue-circle');

if (parallaxEffect.length) {
    new simpleParallax(parallaxEffect, {
        overflow: true,
        orientation: 'down',
        maxTransition: 99,
        scale: 2,
        customWrapper: '.custom-container',
    });
}
if (parallaxEffect2.length) {
    new simpleParallax(parallaxEffect2, {
        overflow: true,
        orientation: 'up right',
        maxTransition: 99,
        scale: 3,
    });
}
if (parallaxEffect3.length) {
    new simpleParallax(parallaxEffect3, {
        overflow: true,
        orientation: 'up left',
        maxTransition: 99,
        scale: 3,
    });
}

const sceneElement = document.getElementById('scene');
if (sceneElement) {
    new Parallax(sceneElement);
}
